import * as React from 'react'

import { DATE_FILTER_KINDS } from 'modules/core/components/DataTable/constants'
import type { Filter as FilterType } from 'modules/core/components/DataTable/types'
import Filter from 'modules/core/components/Filter'

import Header from './Header'

type Props<T> = {
  filter: FilterType<T>
  onValueChange: (value: unknown) => void
  onCategoryChange: (category: FilterType<T>['category']) => void
  defaultOpen?: boolean
}

export default function DateFilter<T>({
  filter: dataTableFilter,
  onValueChange,
  onCategoryChange,
  defaultOpen,
}: Props<T>) {
  const { filter, category, value } = dataTableFilter

  const showHeader = filter.categories.length > 1
  const header = showHeader && (
    <Header filter={filter} category={category} onCategoryChange={onCategoryChange} />
  )

  const commonProps = {
    label: filter.title,
    onValueChange,
    header,
  }

  switch (category.kind) {
    case DATE_FILTER_KINDS.DATE_PICKER:
      switch (category.operation) {
        case 'eq':
          return (
            <Filter.DatePicker
              mode="single"
              value={value as string | undefined}
              defaultOpen={defaultOpen}
              {...commonProps}
            />
          )
        case 'between':
          return (
            <Filter.DatePicker
              mode="range"
              value={value as [string | undefined, string | undefined]}
              defaultOpen={defaultOpen}
              closeOnChange={false}
              {...commonProps}
            />
          )
      }
    case DATE_FILTER_KINDS.DATE_TIME_PICKER:
      switch (category.operation) {
        case 'eq':
          return (
            <Filter.DateTimePicker
              mode="single"
              value={value as string | undefined}
              defaultOpen={defaultOpen}
              {...commonProps}
            />
          )
        case 'between':
          return (
            <Filter.DateTimePicker
              mode="range"
              value={value as [string | undefined, string | undefined]}
              defaultOpen={defaultOpen}
              closeOnChange={false}
              {...commonProps}
            />
          )
      }
  }

  throw new Error(`Unknown filter kind: ${category.kind}`)
}
